// Lib
import { createSelector } from 'reselect';

// Utils
import { prop } from '../../common/utils/immutableHelper';

export const getRemoteSelectedElementDetails = (state) => state.getIn(['remoteActivity', 'selectedElements']);

/**
 * Gets an array of remote user IDs with their element ID selections, only if they're selecting an element.
 * E.g. [['619735040c233097dea8cd21', '1NZ67G00J3HE4C'], ...]
 */
export const getRemoteUserIdsWithSelections = createSelector(
    getRemoteSelectedElementDetails,
    // selectedElementDetails => selectedElementDetails.map((value, elementId) => [prop('userId', value), first(elementId)]),
    (selectedElementDetails) =>
        selectedElementDetails.map((value, elementId) => [prop('userId', value), elementId]).toArray(),
);

const getRemoteCommentThreadDetails = (state) => state.getIn(['remoteActivity', 'commentThreads']);

const getRemoteUserIdsEditingComments = createSelector(getRemoteCommentThreadDetails, (remoteCommentThreadDetails) =>
    remoteCommentThreadDetails.reduce((acc, el, elementId) => {
        el.keySeq().forEach((key) => {
            acc.push([key, elementId]);
        });
        return acc;
    }, []),
);

export const getRemoteUserIdsAlreadyShowingActivity = createSelector(
    getRemoteUserIdsWithSelections,
    getRemoteUserIdsEditingComments,
    (remoteUserIdsWithSelections, remoteUserIdsEditingComments) => [
        ...remoteUserIdsWithSelections,
        ...remoteUserIdsEditingComments,
    ],
);
